import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/search',
    component: ComponentCreator('/search', '5de'),
    exact: true
  },
  {
    path: '/docs',
    component: ComponentCreator('/docs', '91b'),
    routes: [
      {
        path: '/docs',
        component: ComponentCreator('/docs', 'f6e'),
        routes: [
          {
            path: '/docs',
            component: ComponentCreator('/docs', '133'),
            routes: [
              {
                path: '/docs/career-mode/faq',
                component: ComponentCreator('/docs/career-mode/faq', '972'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/getting-started',
                component: ComponentCreator('/docs/career-mode/getting-started', 'dc4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/how-matching-works',
                component: ComponentCreator('/docs/career-mode/how-matching-works', 'a8b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/job-preferences',
                component: ComponentCreator('/docs/career-mode/job-preferences', '6d4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/overview',
                component: ComponentCreator('/docs/career-mode/overview', 'd91'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/privacy-and-trust',
                component: ComponentCreator('/docs/career-mode/privacy-and-trust', 'a03'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/profile-setup',
                component: ComponentCreator('/docs/career-mode/profile-setup', '416'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/career-mode/reviewing-opportunities',
                component: ComponentCreator('/docs/career-mode/reviewing-opportunities', 'e58'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/customize-your-feed/density',
                component: ComponentCreator('/docs/customize-your-feed/density', '268'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/customize-your-feed/layout',
                component: ComponentCreator('/docs/customize-your-feed/layout', 'a60'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/customize-your-feed/preferences',
                component: ComponentCreator('/docs/customize-your-feed/preferences', '25e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/customize-your-feed/theme',
                component: ComponentCreator('/docs/customize-your-feed/theme', 'e26'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/for-content-creators/claiming-ownership-on-article',
                component: ComponentCreator('/docs/for-content-creators/claiming-ownership-on-article', '58e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/for-content-creators/content-guidelines',
                component: ComponentCreator('/docs/for-content-creators/content-guidelines', '540'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/for-content-creators/how-to-get-featured',
                component: ComponentCreator('/docs/for-content-creators/how-to-get-featured', 'de5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/for-content-creators/suggest-new-source',
                component: ComponentCreator('/docs/for-content-creators/suggest-new-source', 'fae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/getting-started/browser-extension-installation',
                component: ComponentCreator('/docs/getting-started/browser-extension-installation', '869'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/getting-started/pwa',
                component: ComponentCreator('/docs/getting-started/pwa', '2ae'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/intro',
                component: ComponentCreator('/docs/intro', '61d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/bookmarks',
                component: ComponentCreator('/docs/key-features/bookmarks', '503'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/community-picks',
                component: ComponentCreator('/docs/key-features/community-picks', '91b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/discussions',
                component: ComponentCreator('/docs/key-features/discussions', '5d7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/feeds',
                component: ComponentCreator('/docs/key-features/feeds', 'c76'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/pause-new-tab',
                component: ComponentCreator('/docs/key-features/pause-new-tab', '879'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/polls',
                component: ComponentCreator('/docs/key-features/polls', 'f66'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/search',
                component: ComponentCreator('/docs/key-features/search', '175'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/the-companion',
                component: ComponentCreator('/docs/key-features/the-companion', '3fc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/key-features/upvotes',
                component: ComponentCreator('/docs/key-features/upvotes', 'e51'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/monetization/awards',
                component: ComponentCreator('/docs/monetization/awards', '2a8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/monetization/boost',
                component: ComponentCreator('/docs/monetization/boost', 'be9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/monetization/cores',
                component: ComponentCreator('/docs/monetization/cores', 'fd0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/billing-management',
                component: ComponentCreator('/docs/organizations/billing-management', '707'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/creating-organization',
                component: ComponentCreator('/docs/organizations/creating-organization', '4c9'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/inviting-members',
                component: ComponentCreator('/docs/organizations/inviting-members', '53a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/managing-members',
                component: ComponentCreator('/docs/organizations/managing-members', 'd7e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/managing-organization',
                component: ComponentCreator('/docs/organizations/managing-organization', '132'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/organizations/overview',
                component: ComponentCreator('/docs/organizations/overview', '8d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/bookmark-folders',
                component: ComponentCreator('/docs/plus/bookmark-folders', '890'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/clickbait-shield',
                component: ComponentCreator('/docs/plus/clickbait-shield', '000'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/custom-feeds',
                component: ComponentCreator('/docs/plus/custom-feeds', '885'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/keyword-filters',
                component: ComponentCreator('/docs/plus/keyword-filters', 'c65'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/plus-overview',
                component: ComponentCreator('/docs/plus/plus-overview', '2d1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/presidential-briefing',
                component: ComponentCreator('/docs/plus/presidential-briefing', '42a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/public-api',
                component: ComponentCreator('/docs/plus/public-api', 'e1d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/plus/smart-prompts',
                component: ComponentCreator('/docs/plus/smart-prompts', '9cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/setting-up-your-feed/advanced-filtering-options',
                component: ComponentCreator('/docs/setting-up-your-feed/advanced-filtering-options', '7cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/setting-up-your-feed/blocking-tags-sources',
                component: ComponentCreator('/docs/setting-up-your-feed/blocking-tags-sources', '9cd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/setting-up-your-feed/filtering-content-feed',
                component: ComponentCreator('/docs/setting-up-your-feed/filtering-content-feed', '39d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/creating-your-squad',
                component: ComponentCreator('/docs/squads/creating-your-squad', '85b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/featured-squads',
                component: ComponentCreator('/docs/squads/featured-squads', '230'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/growing-your-squad',
                component: ComponentCreator('/docs/squads/growing-your-squad', '8b8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/moderating-your-squad',
                component: ComponentCreator('/docs/squads/moderating-your-squad', '726'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/public-squads',
                component: ComponentCreator('/docs/squads/public-squads', 'fd0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/squads/slack-integration',
                component: ComponentCreator('/docs/squads/slack-integration', '885'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/account-details',
                component: ComponentCreator('/docs/your-profile/account-details', 'e96'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/activity',
                component: ComponentCreator('/docs/your-profile/activity', '11c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/deleting-your-profile',
                component: ComponentCreator('/docs/your-profile/deleting-your-profile', 'b7e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/devcard',
                component: ComponentCreator('/docs/your-profile/devcard', '580'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/reading-history',
                component: ComponentCreator('/docs/your-profile/reading-history', 'e9c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/reputation',
                component: ComponentCreator('/docs/your-profile/reputation', '361'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/stack-and-tools',
                component: ComponentCreator('/docs/your-profile/stack-and-tools', 'a46'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/top-readers',
                component: ComponentCreator('/docs/your-profile/top-readers', '6b0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/verified-badge',
                component: ComponentCreator('/docs/your-profile/verified-badge', '701'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/docs/your-profile/weekly-goal',
                component: ComponentCreator('/docs/your-profile/weekly-goal', '8cc'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', '2e1'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
